import { render, staticRenderFns } from "./SvgEditor.vue?vue&type=template&id=1715792c&"
import script from "./SvgEditor.vue?vue&type=script&lang=ts&"
export * from "./SvgEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports